import {useLocation} from 'react-router-dom';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';

import styles from 'assets/jss/Scan/AddPatientStyles';
import MainHeader from '../Header/MainHeader';
import AddOrEditPatient from 'components/AddOrEditForm/AddOrEditPatient';
import {usePatientInfo} from 'hooks/usePatient';
import useEditPatientProfile from 'hooks/useEditPatientProfile';
const useStyles = makeStyles(styles);

export default function EditPatient() {
    const {state} = useLocation();

    const classes = useStyles();
    const {data: patientInfo} = usePatientInfo(state.patientId);
    const editPatientProfile = useEditPatientProfile();

    const editPatientProfileHandler = (data) => {
        editPatientProfile.mutate({
            id: state.patientId,
            data,
        });
    };

    return (
        <>
            <MainHeader editPatientProfile showBackBtn />
            <Grid container className={classes.root} pb={6} paddingX='17px'>
                <Grid xs={12} item className={classes.containerForm}>
                    <AddOrEditPatient
                        type='edit'
                        data={patientInfo}
                        disabled={editPatientProfile.isLoading}
                        actionHandler={editPatientProfileHandler}
                    />
                </Grid>
            </Grid>
        </>
    );
}
